<nb-card style="height: 100%" [nbSpinner]="this.isLoading">
  <nb-card-body>
    <form (ngSubmit)="submit()" name="employeeInputForm" id="employeeInputForm" #employeeInputForm="ngForm">
      <div class="row">
        <div class="col-lg-12">
          <nb-card style="border-left: solid; border-left-color: #243d5b; border-left-width: 5px;">
            <nb-card-header>
              <div class="row">
                <div class="col-lg-12">
                  <h5 *ngIf="this.employee.id">Update Employee</h5>
                  <h5 *ngIf="!this.employee.id">New Employee</h5>
                </div>
              </div>
              <mat-divider style="margin-top: 20px;"></mat-divider>
            </nb-card-header>
            <nb-card-body>
              <div class="row">
                <div class="col-lg-6 col-12">
                  <mat-form-field style="width: 100%">
                    <mat-label>First Name</mat-label>
                    <input matInput [(ngModel)]="this.employee.firstName" [value]="this.employee.firstName" matInput type="text"
                      required #employeefirstNameInput id="employeefirstNameInput" name="employeefirstNameInput" >
                  </mat-form-field>
                </div>
                <div class="col-lg-6 col-12">
                  <mat-form-field style="width: 100%">
                    <mat-label>Last Name</mat-label>
                    <input matInput [(ngModel)]="this.employee.lastName" [value]="this.employee.lastName" matInput type="text"
                      required #employeeLastNameInput id="employeeLastNameInput" name="employeeLastNameInput" >
                  </mat-form-field>
                </div>
                <div class="col-lg-6 col-12">
                  <mat-form-field style="width: 100%">
                    <mat-label>Middle Initial</mat-label>
                    <input matInput [(ngModel)]="this.employee.middleInitial" [value]="this.employee.middleInitial" matInput type="text"
                      #employeemiddleInitialInput id="employeemiddleInitialInput" name="employeemiddleInitialInput" >
                  </mat-form-field>
                </div>
                <div class="col-lg-6 col-12">
                  <mat-form-field style="width: 100%">
                    <mat-label>Address</mat-label>
                    <input matInput [(ngModel)]="this.employee.streetAddress" [value]="this.employee.streetAddress" matInput type="text"
                      #employeestreetAddressInput id="employeestreetAddressInput" name="employeestreetAddressInput" >
                  </mat-form-field>
                </div>
                <div class="col-lg-6 col-12">
                  <mat-form-field style="width: 100%">
                    <mat-label>Crew</mat-label>
                    <mat-select [(ngModel)]="this.employee.crewId" [(value)]="this.employee.crewId" name="crew">
                      <mat-option *ngFor="let v of this.crews" [value]="v.id">
                        {{v.crewName}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-lg-6 col-12">
                  <mat-form-field style="width: 100%">
                    <mat-label>Employee #</mat-label>
                    <input matInput [(ngModel)]="this.employee.integrationId" [value]="this.employee.integrationId" matInput type="text"
                      #integrationIdInput id="integrationIdInput" name="integrationIdInput" placeholder="Employee #" disabled>
                  </mat-form-field>
                </div>
              </div>
              <!-- <div class="row">
                <div class="col-lg-6 col-12">
                  <mat-checkbox color="primary" [(ngModel)]="this.employee.isActive" name="isActiveCheck" id="isActiveCheck">
                    <p style="margin: auto;">Is Active</p>
                  </mat-checkbox>
                </div>

              </div> -->
            </nb-card-body>
            <nb-card-footer>
              <div class="row">
                <div class="col-lg-6 col-4" style="text-align: left;">
                  <button mat-button type="button" style="padding: 0px;" (click)="cancel();">
                    <fa-icon [icon]="faArrowAltCircleLeft" size="lg"></fa-icon>
                    Cancel
                  </button>
                </div>
                <div class="col-lg-6 co-8" style="text-align: right">
                  <button *ngIf="this.employee.id" class="clearButton" mat-button type="button"
                    (click)="deletePackageType()">
                    Delete
                  </button>
                  <button class="saveButton" mat-button type="submit" [disabled]="!employeeInputForm.valid">
                    Save
                  </button>
                </div>
              </div>
            </nb-card-footer>
          </nb-card>
        </div>
      </div>
    </form>
  </nb-card-body>
</nb-card>